import React from 'react';
import { Grid, Typography } from '@mui/material';
import { IFacilitySectionProps } from 'app/models/Orders/OrderDetails';
import { useStyles } from './OrderDetailsReportStyles';
import { useTranslation } from 'react-i18next';

type FacilitySectionProps = {
  facilityDetails: IFacilitySectionProps;
};
export const OrderDetailsReportFacilityInfo = (props: FacilitySectionProps) => {
  const { classes } = useStyles();
  const facilityDetails = props.facilityDetails;
  const { t } = useTranslation();

  return (
    <Grid container>
      <Grid container>
        <Grid xs={6} md={2} className={`${classes.labelCell}`}>
          <Typography>{t('order.orderReportDetails.facilitySection.donotcallfacility')}:</Typography>
        </Grid>
        <Grid xs={6} md={4} className={`${classes.dataCell}`}>
          {facilityDetails.doNotCallFacility}
        </Grid>
        <Grid xs={6} md={3} className={`${classes.labelCell}`}>
          <Typography>{t('order.orderReportDetails.facilitySection.postponementpenaltyamount')}:</Typography>
        </Grid>
        <Grid xs={6} md={3} className={`${classes.dataCell}`}>
          {facilityDetails.postponementPenaltyAmt}
        </Grid>
      </Grid>

      <Grid container>
        <Grid xs={6} md={2} className={`${classes.alternativeLabelCell}`}>
          <Typography>{t('order.orderReportDetails.facilitySection.facilitytype')}:</Typography>
        </Grid>
        <Grid xs={6} md={4} className={`${classes.alternativeDataCell}`}>
          {facilityDetails.facilityType}
        </Grid>
        <Grid xs={6} md={3} className={`${classes.alternativeLabelCell}`}>
          <Typography>{t('order.orderReportDetails.facilitySection.postponedmentpenaltyfrequency')}:</Typography>
        </Grid>
        <Grid xs={6} md={3} className={`${classes.alternativeDataCell}`}>
          {facilityDetails.postPonementPenaltyFreq}
        </Grid>
      </Grid>

      <Grid container>
        <Grid xs={6} md={2} className={`${classes.labelCell}`}>
          <Typography>{t('order.orderReportDetails.facilitySection.location')}:</Typography>
        </Grid>
        <Grid xs={6} md={4} className={`${classes.dataCell}`}>
          {facilityDetails.facilityCity || '- -'}
        </Grid>
        <Grid xs={6} md={3} className={`${classes.labelCell}`}>
          <Typography>{t('order.orderReportDetails.facilitySection.cancellationpenaltyamounts')}:</Typography>
        </Grid>
        <Grid xs={6} md={3} className={`${classes.dataCell}`}>
          {facilityDetails.cancellationPenaltyAmt}
        </Grid>
      </Grid>

      <Grid container>
        <Grid xs={6} md={2} className={`${classes.alternativeLabelCell}`}>
          <Typography>{t('order.orderReportDetails.facilitySection.website')}:</Typography>
        </Grid>
        <Grid xs={6} md={4} className={`${classes.alternativeDataCell}`}>
          {facilityDetails.website}
        </Grid>
        <Grid xs={6} md={3} className={`${classes.alternativeLabelCell}`}>
          <Typography>{t('order.orderReportDetails.facilitySection.cancellationpenalty')}:</Typography>
        </Grid>
        <Grid xs={6} md={3} className={`${classes.alternativeDataCell}`}>
          {facilityDetails.cancellationPenaltyFreq}
        </Grid>
      </Grid>

      <Grid container>
        <Grid xs={6} md={2} className={`${classes.labelCell}`}>
          <Typography>{t('order.orderReportDetails.facilitySection.currentassignments')}:</Typography>
        </Grid>
        <Grid xs={6} md={4} className={`${classes.dataCell}`}>
          {facilityDetails.currentAssignments}
        </Grid>
        <Grid xs={6} md={3} className={`${classes.labelCell}`}>
          <Typography>{t('order.orderReportDetails.facilitySection.completedwithinlast12months')}:</Typography>
        </Grid>
        <Grid xs={6} md={3} className={`${classes.dataCell}`}>
          {facilityDetails.currentAssignments}
        </Grid>
      </Grid>

      <Grid container>
        <Grid xs={6} md={2} className={`${classes.alternativeLabelCell}`}>
          <Typography>{t('order.orderReportDetails.facilitySection.noofbeds')}:</Typography>
        </Grid>
        <Grid xs={6} md={10} className={`${classes.alternativeDataCell}`}>
          {facilityDetails.numberOfBeds}
        </Grid>

        <Grid xs={6} md={2} className={`${classes.labelCell}`}>
          <Typography>{t('order.orderReportDetails.facilitySection.notes')}:</Typography>
        </Grid>
        <Grid xs={6} md={9} className={`${classes.dataCell}`}>
          {facilityDetails.facilityPreferenceNotes?.split('\n').length > 1
            ? facilityDetails.facilityPreferenceNotes?.split('\n').map(str => <Typography>{str}</Typography>)
            : facilityDetails.facilityPreferenceNotes}
        </Grid>
      </Grid>
    </Grid>
  );
};
